import defaults from './challengeDefaults.js'

const state = Object.assign({}, defaults)
export default state
